module.exports = __webpack_public_path__ + "img/hand-ico.00b69322.svg";